module.exports = __webpack_public_path__ + "static/media/am.8b42c952.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/am.svg
// module id = 855
// module chunks = 0